import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FromService } from 'src/app/services/form/from.service';
import { FieldType, FormFieldItem, Lang } from 'src/app/models/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-field-modal',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './field-modal.component.html',
  styleUrl: './field-modal.component.css'
})
export class FieldModalComponent implements OnInit {
  @Input() lang: Lang = 'geo';

  // Optional: allow parent to pass pages list for the select
  @Input() pages: Array<{ menu_page: number; title: string }> = [];
  // Optional: preselected page (menu_page) when opening modal
  @Input() menuPage?: number;

  // Fallback page list (if parent doesn't pass anything)
  // You can fill this from parent later; keeping here avoids template errors.
  pagesFallback: Array<{ menu_page: number; title: string }> = [];

  @Input() formId!: number;
  @Input() field?: FormFieldItem;

  saving = false;

  form!: FormGroup;

  types: FieldType[] = ['text','email','number','textarea','checkbox','radio','select','file','date'];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private api: FromService
  ) {}

  ngOnInit(): void {
    const initialMenuPage =
      this.menuPage ??
      (this.pages?.length ? this.pages[0].menu_page : null);

    this.form = this.fb.group({
      // menu_page: [initialMenuPage, Validators.required],

      type: [this.field?.type ?? 'text', Validators.required],
      name: [this.field?.name ?? '', [Validators.required, Validators.maxLength(64)]],
      label: [this.field?.label ?? '', [Validators.required, Validators.maxLength(255)]],
      placeholder: [this.field?.placeholder ?? ''],
      required: [this.field?.required ?? 0],
      options: [this.field?.options_json ? this.safeParseOptions(this.field.options_json) : ''] // textarea text
    });
  }

  private safeParseOptions(json: string): string {
    try {
      const arr = JSON.parse(json);
      return Array.isArray(arr) ? arr.join('\n') : '';
    } catch {
      return '';
    }
  }

  private optionsToJson(): string | null {
    const t = (this.form.value.options ?? '').trim();
    if (!t) return null;
    const arr = t.split('\n').map((x: string) => x.trim()).filter(Boolean);
    return JSON.stringify(arr);
  }

  get pagesForSelect(): Array<{ menu_page: number; title: string }> {
    return (this.pages && this.pages.length) ? this.pages : this.pagesFallback;
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.saving = true;

    // menu_page is selected in UI (required), but we keep using formId for create/update
    // This prevents saving without selecting a page.
    // if (!this.form.value.menu_page) {
    //   this.saving = false;
    //   return;
    // }

    const payload: any = {
      type: this.form.value.type,
      name: this.form.value.name,
      label: this.form.value.label,
      placeholder: this.form.value.placeholder || null,
      required: this.form.value.required ? 1 : 0,
    };

    // options only for select/radio/checkbox
    const needsOptions = ['select','radio','checkbox'].includes(payload.type);
    payload.options_json = needsOptions ? this.optionsToJson() : null;

    const req$ = this.field
      ? this.api.updateField(this.formId, this.field.id, payload, this.lang)
      : this.api.createField(this.formId, payload, this.lang);

    req$.subscribe({
      next: () => {
        this.saving = false;
        this.activeModal.close(true);
      },
      error: () => (this.saving = false)
    });
  }
}